import React, { useContext } from 'react';
import { Container } from '@material-ui/core';
import experience from '../../assets/lottie/development.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import { experienceData } from '../../data/experienceData';
import ExperienceCard from './ExperienceCard';
import AnimationLottie from '../Animation';
import './Experience.css';

function Experience() {
    const { theme } = useContext(ThemeContext);

    const styles = {
        wrapper: { backgroundColor: theme.secondary },
        title: { color: theme.primary }
    };

    return (
        <div style={styles.wrapper}>
            <Container className="experience" id="experience">
                <div className="experience-body">
                    <div className="experience-image">
                        <AnimationLottie animationPath={experience} />
                    </div>
                    
                    <div className="experience-description">
                        <h1 style={styles.title}>Experience</h1>
                        {experienceData.map((exp) => (
                            <ExperienceCard key={exp.id} {...exp} />
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Experience;